import styled from 'styled-components'

export const TextPrimary = styled.p`
    color: ${({ theme }) => theme.textPrimary};
    font-size: 14px;
    font-weight: 400;
    line-height: 26.4px;
`
export const TextSecondary = styled.p`
    color: ${({ theme }) => theme.textSecondary};
    font-size: 14px;
    font-weight: 400;
    line-height: 26.4px;
`
